<template>
  <div class="page">
    <f7-navbar title="學習型實習" back-link="Back" @click="backIndex()">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="page-content">
      <header class="wave-header sticky-top"></header>
      <p class="segmented segmented-round">
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':progressActive}" v-on:click="changeButton('progress')">資料確認</button>
      <!--
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':checkActive}" v-on:click="changeButton('checking')">審核通過</button>
      -->
      <button :class="{'button':true,'button-round':true,'button-outline':true,'button-active':approvedActive}" v-on:click="changeButton('approved')">審核通過</button>
    </p>

    <div id="progress" v-if="progressActive">
    <div class="block-header">114 學年度第 2 學期</div>
      <div class="list">
        
        <ul v-if="!progressLoading">
          <li v-for="(item,index) in progressData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.reviewDesc }}
                  <div class="item-footer sub-content">
                    <span>{{ item.updateAt.toString().split("T")[0] }}</span>
                  </div>
                </div>
                <div class="item-after dollar">+ {{ item.coinNumber }} 點</div>
              </div>
            </a>
          </li>
          <template v-if="progressData.length === 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
            </div> 
          </template>
        </ul>
      </div>

    </div>

    <div id="checking" v-if="checkActive">
      <div class="list">
        <ul v-if="!checkLoading">
          <li v-for="(item,index) in checkData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.courseName }}
                  <div class="item-footer sub-content">
                    <span>{{ item.classAt.toString().split("T")[0] }}</span>
                    <span class="hours">{{ item.classHours }}</span>
                  </div>
                </div>
                <div class="item-after dollar">+ {{ item.allowHours }} 點</div>
              </div>
            </a>
          </li>
          <template v-if="checkData.length == 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
            </div> 
          </template>
        </ul>
      </div>


    </div>
      <div id="Approved" v-if="approvedActive">
        <div class="block-header" style="color:red">歷史資訊</div>

        <div class="list">

             
        <ul v-if="!approvedLoading">
          <li v-for="(item,index) in approvedData">
            <a href="#" class="item-content">
              <div class="item-inner">
                <div class="item-title">
                  {{ item.schoolYear }}-{{ item.semester }}  * {{ item.reviewDesc }}
                  <div class="item-footer sub-content">
                    <span>{{ item.updateAt.toString().split("T")[0] }}</span>
                    <span class="hours">{{ item.classHours }}</span>
                  </div>
                </div>
                 <div class="item-after dollar">+ {{ item.coinNumber }} 點</div>
              </div>
            </a>
          </li>
          <template v-if="approvedData.length == 0 ">
            <div class="page-empty">
              <img src="../../images/background-img/study-grey.png" alt />
              <h3>目前尚無任何紀錄</h3>
             </div> 
          </template>
        </ul>
      </div>

      </div>
    </div>
    
  </div>
  
</template>

<script>
import Service from "../../service";
import axios from '../../js/axiosModule';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      progressData:[],
      progressLoading:false,
      progressActive:true,
      checkData:[],
      checkLoading:false,
      checkActive:false,
      approvedData:[],
      approvedLoading:false,
      approvedActive:false
    };
  },
  created: function() {},
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    getCoinData :function() {
      let self = this;
      self.progressLoading = true;
      self.checkLoading = true;
      self.approvedLoading = true;
      var params={};

      params.schoolYear="114";
      params.semester="2";
      params.learnDetailCode="40";
      params.studentNo=self.$store.state.userInfo.studentNo;
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Learn/GetStudentLearnDetailByParam",params).then((response)=> {
        console.log(response.data);
       
        self.progressData = response.data.data; 
        self.progressLoading = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });

      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Learn/GetStudentLearnDetailHisByParam",params).then((response)=> {
        console.log(response.data);
       
        self.approvedData = response.data.data; 
      self.approvedLoading = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });

    },changeButton : function(objType) {
      let self = this;
      if( objType === "progress" ) {
        self.progressActive = true;
       // self.checkActive = false;
        self.approvedActive = false;
      } else if ( objType === "checking" ) {
        self.progressActive = false;
       // self.checkActive = true;
        self.approvedActive = false;
      } else if ( objType === "approved" ) {
        self.progressActive = false;
       // self.checkActive = false;
        self.approvedActive = true;
      }
    },
    getHalfTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss").month(1)._d;
      return dateTime;
    },
     getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    },
    backIndex:function() {
      this.$f7router.navigate("/" );
    },
  },mounted() {
    let self = this;
    //self.getCoachClassRecord();
    self.getCoinData();
  },
  computed: {
    computedDate: function(date) {
      return date.split("T")[0]
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/my-coin/coin-detail40.vue